import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./TauriApplicationMenuItems.css";
import TauriImage from "../TauriImage/TauriImage";

const TauriApplicationMenuItems = ({ items }) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [showMore, setShowMore] = useState(false);

    const dropdownRef = useRef(null);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1280);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1280);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMore(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const MAX_VISIBLE = isMobile ? 3 : items.length;
    const visibleItems = items.slice(0, MAX_VISIBLE);
    const overflowItems = items.slice(MAX_VISIBLE);

    const isItemActive = (path) =>
        currentPath === path || currentPath.startsWith(`${path}/`);

    return (
        <ul className="tauri-application-menu navbar-nav d-flex flex-row tauri-menu-container w-100">
            {visibleItems.map((item, idx) => (
                <li className="nav-item" key={idx}>
                    <Link
                        to={item.path}
                        className={`nav-link tauri-menu-item ${isItemActive(item.path) ? "active" : ""
                            }`}
                    >
                        <TauriImage
                            localImage={item.icon}
                            alt={item.name}
                            className={"tauri-menu-icon me-2"}
                        />
                        {item.name}
                    </Link>
                </li>
            ))}

            {overflowItems.length > 0 && (
                <li
                    ref={dropdownRef}
                    className={`nav-item d-flex align-items-center dropdown ${overflowItems.some(i => isItemActive(i.path)) ? "active" : ""
                        }`}
                >
                    <span
                        className="nav-link tauri-menu-item dropdown-toggle btn-more"
                        onClick={() => setShowMore(!showMore)}
                    >
                        <TauriImage
                            localImage={"/Images/arrow-right.svg"}
                            className={`more-icon ${showMore ? "rotate" : ""}`}
                            color={"#FFF"}
                        />
                    </span>

                    {showMore && (
                        <ul className="dropdown-menu dropdown-menu-end show">
                            {overflowItems.map((item, idx) => (
                                <li key={idx}>
                                    <Link
                                        to={item.path}
                                        className={`dropdown-item d-flex align-items-center ${isItemActive(item.path) ? "active" : ""
                                            }`}
                                        onClick={() => setShowMore(false)}
                                    >
                                        <TauriImage
                                            localImage={item.icon}
                                            alt={item.name}
                                            className={"tauri-menu-icon me-2"}
                                        />
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                </li>
            )}
        </ul>
    );
};

export default TauriApplicationMenuItems;
